// @ts-nocheck
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
/* Store Custom Code - Start */
import { addProductWithResult } from "@store/Framework/Services/StoreCartService";
/* Store Custom Code - End */
import {
    chain,
    PopulateApiParameter as basePopulateApiParameter,
    SendDataToApi as baseSendDataToApi,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { getCuttingInstructions } from "@store/Framework/Store/Store/Data/CuttingInstructions/CuttingInstructionsSelectors";
import setCuttingInstructions from "@store/Framework/Store/Store/Data/CuttingInstructions/Handlers/SetCuttingInstructions";
import {
    addToEndOfChain,
    createChainHandler,
    executeAwaitableHandlerChain,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    throwErrorIfTesting();

    /* Store Custom Code - Start */
    const state = props.getState();
    const cuttingInstructions = getCuttingInstructions(state);

    const newParameters =
        props.parameter.productId === cuttingInstructions.productId && cuttingInstructions.requiresCut
            ? {
                  ...props.parameter,
                  requiresCut: true,
                  notes: cuttingInstructions.requiresCutDescription,
              }
            : props.parameter;

    props.apiParameter = newParameters;
    /* Store Custom Code - End */
});

replaceInChain(chain, basePopulateApiParameter, PopulateApiParameter);

export const SendDataToApi = createChainHandler("SendDataToApi", chain, async props => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        if (!result.errorMessage.includes("multipleSaleQty") /* Store Custom Code */) {
            return false;
        }
    }
});

replaceInChain(chain, baseSendDataToApi, SendDataToApi);

export const ResetCuttingInstructions = createChainHandler("ResetCuttingInstructions", chain, async props => {
    await executeAwaitableHandlerChain(
        setCuttingInstructions,
        { productId: "", requiresCut: false, requiresCutDescription: "" },
        props,
    );
});

addToEndOfChain(chain, ResetCuttingInstructions);
